import { useTranslation } from 'react-i18next'
import { Press } from '@dorixona/ui'
import { Sheet } from '../../ui/Sheet'
import { Icon } from '../../ui/Icon'
import { Flag } from '../../ui/Flag'
import { useLanguage } from '../../app/language'

export interface LanguageSheetProps {
  opened: boolean
  onClose: () => void
}

/**
 * Выбор языка шторкой. Каждый язык подписан на себе самом: узнать свой проще,
 * чем прочитать чужой. Выбрали — язык меняется, шторка закрывается.
 */
export function LanguageSheet({ opened, onClose }: LanguageSheetProps) {
  const { t } = useTranslation('common')
  const { language, languages, change } = useLanguage()

  return (
    <Sheet opened={opened} label={t('language.label')} onClose={onClose}>
      <div className="fsheet">
        <div className="fhead">
          <h2>{t('language.label')}</h2>
          <Press squish="icon" className="fclose" aria-label={t('actions.close')} onPress={onClose}>
            <Icon name="i-x" size={18} />
          </Press>
        </div>
        <div className="langlist" role="radiogroup" aria-label={t('language.label')}>
          {languages.map((code) => (
            <Press
              key={code}
              role="radio"
              squish="row"
              haptic="select"
              lang={code}
              aria-checked={code === language}
              className={code === language ? 'langopt on' : 'langopt'}
              onPress={() => {
                change(code)
                onClose()
              }}
            >
              <Flag code={code} className="langopt__flag" />
              <span className="langopt__name">{t(`language.${code}`, { lng: code })}</span>
              {code === language ? <Icon name="i-check" size={20} /> : null}
            </Press>
          ))}
        </div>
      </div>
    </Sheet>
  )
}
